import { Base } from 'layouts'

import { ThemeContext } from 'App'
import AlertsModal from 'components/Alerts/AlertsModal'
import { ModuleCard } from 'components/Cards/ModuleCards'
import { theme } from 'config'
import { THEMES_NAME } from 'config/theme.config'
import { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { UserStorageService } from 'services'
import { RootState } from 'store'
import { alertActions } from 'store/Alert'
import { viewModuleActions } from 'store/ViewModule'
import { all as viewModuleSelector } from 'store/ViewModule/ViewModule.selector'
import * as S from './styled'

export function ViewModules() {
  const dispatch = useDispatch()
  const { viewModules } = useSelector(viewModuleSelector)
  console.log(viewModules)
  const [selected, setSelected] = useState(null)
  const history = useHistory()
  const { setTheme } = useContext(ThemeContext)
  const alert = useSelector((state: RootState) => state.alert.alert)
  const [isAlertModalVisible, setIsAlertModalVisible] = useState(false)

  function handleSelect(module) {
    // Configurar tema
    const themeToSet = THEMES_NAME[module.theme] || THEMES_NAME.jbsFriboi
    setTheme(themeToSet)
    UserStorageService.setViewModuleTheme(themeToSet)

    // Verificar se é o Friboi e tem submódulos
    if (
      module.name === 'Friboi' &&
      module.subModules &&
      module.subModules.length > 0
    ) {
      // Procurar pelo submódulo "In Natura"
      const inNaturaModule = module.subModules.find(
        (sub: any) => sub.name === 'In Natura' || sub.model === 'INNATURA'
      )

      if (inNaturaModule) {
        // Configurar o submódulo selecionado
        UserStorageService.setViewModule(inNaturaModule.id)
        UserStorageService.setViewModuleType(inNaturaModule.model)

        // Definir o tema específico para in natura (agora com aba Matéria Prima)
        const inNaturaTheme = inNaturaModule.theme || 'friboiInnatura'
        setTheme(inNaturaTheme)
        UserStorageService.setViewModuleTheme(inNaturaTheme)

        // Navegar diretamente para a página de notas fiscais do submódulo in natura
        history.push(`${inNaturaModule.link}`)
        return
      }
    }

    // Verificar se é o Swift e redirecionar para a tela do Friboi com tema Swift
    if (module.name === 'Swift') {
      // Buscar o módulo Friboi para pegar o submódulo In Natura
      const friboiModule = viewModules.find(mod => mod.name === 'Friboi')

      if (friboiModule && friboiModule.subModules) {
        const inNaturaModule = friboiModule.subModules.find(
          (sub: any) => sub.name === 'In Natura' || sub.model === 'INNATURA'
        )

        if (inNaturaModule) {
          // Configurar o submódulo In Natura do Friboi
          UserStorageService.setViewModule(inNaturaModule.id)
          UserStorageService.setViewModuleType(inNaturaModule.model)

          // Definir o tema Swift (diferente do Friboi)
          setTheme('swift')
          UserStorageService.setViewModuleTheme('swift')

          // Navegar para a tela do Friboi In Natura
          history.push(`${inNaturaModule.link}`)
          return
        }
      }
    }

    // Comportamento padrão para outros módulos
    setSelected(module)
  }

  useEffect(() => {
    const loggedInUser = UserStorageService.getUserDateForLangDropdown().id
    dispatch(viewModuleActions.getViewModulesNavigation(loggedInUser))
    setTheme(THEMES_NAME.jbsFriboi)
  }, [dispatch, setTheme])

  useEffect(() => {
    dispatch(
      viewModuleActions.setSelectedModule({
        selectedModule: selected
      })
    )
    if (selected && selected.link) {
      const theme = THEMES_NAME[selected.theme] || 'THEMES_NAME.jbsFriboi'
      setTheme(theme)
      UserStorageService.setViewModuleTheme(theme)
      history.push(selected.link)
    }
  }, [selected, history, dispatch, setTheme])

  useEffect(() => {
    if (alert) {
      const timeout = setTimeout(() => {
        setIsAlertModalVisible(true)
      }, 1000) // 1-second delay
      return () => clearTimeout(timeout)
    }
  }, [alert])

  const handleCloseAlertModal = () => {
    setIsAlertModalVisible(false)
    dispatch(alertActions.clearAlert())
  }

  return (
    <Base>
      <S.GridContainer data-testid="view-modules">
        <S.GridIconCard item xs={12} md={8}>
          <S.GridCards item xs={12} md={12}>
            {viewModules.length > 0 &&
              viewModules.map((module, key) => (
                <S.GridCard
                  onClick={() => handleSelect(module)}
                  item
                  xs={12}
                  md={12}
                  key={key}
                >
                  <ModuleCard
                    variant={module.color}
                    title={module.name}
                    redirect={module.link}
                    image={`/images/${module.image}`}
                    icon={
                      theme.appTheme === THEMES_NAME.jbsFriboi
                        ? 'calendar-right-jbs'
                        : 'calendar-right'
                    }
                    isLoading={false}
                  />
                </S.GridCard>
              ))}
          </S.GridCards>
        </S.GridIconCard>
      </S.GridContainer>
      {isAlertModalVisible && alert && (
        <AlertsModal
          visible={isAlertModalVisible}
          alert={alert}
          onClose={handleCloseAlertModal}
        />
      )}
    </Base>
  )
}
